import React from "react";
import style from "./style.module.scss"

const DataTable = ({ data, rowClicked, columClicked,loading }) => {
    const columns = data.columns
    const rows = data.rows

    const getRowSkeleton = () => {
        let skeletons = [];
        for (let i = 0; i < 10; i++) {
            skeletons.push([1,3,4,5,6]);
        }
        return skeletons;
    }

    if (loading) return <table className={style.skeletonTable}>
        <thead className={style.columns}>
            <tr>
                {columns.map((column, index) => (
                    <th key={index}>{column}</th>
                ))}
            </tr>
        </thead>
        <tbody>
            {getRowSkeleton().map((row, index) => (
                <tr key={index} onClick={() => rowClicked(row)}>
                    {row.map((cell, index) => (
                        <td className="skeleton-loader" key={index}></td>
                    ))}
                </tr>
            ))}
        </tbody>
    </table>


    return (
        <table className={style.table}>
            <thead className={style.columns}>
                <tr>
                    {columns.map((column, index) => (
                        <th onClick={()=>columClicked(column)}  key={index}>
                            <span className={style.full}>{column}</span>
                            {
                                column !== "Name" && column !== "Language" && <span class="material-symbols-outlined">swap_vert</span>
                            }
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {
                    rows.length === 0 && <tr>
                        <td colSpan={columns.length} className={style.noData}>No data available</td></tr>
                }
                {rows.map((row, index) => (
                    <tr key={index} onClick={() => rowClicked(row)}>
                        {row.map((cell, index) => (
                            <td key={index}>{cell}</td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    )

}
export default DataTable;